<template>

    <div>

        <top-header title="SERVICECENTER" underline="Reklamationen und Rücksendungen rund um die Uhr + Ihre Bestellung auf einen Blick!"></top-header>

        <div class="container mt-4">

            <div class="row">
                <div class="col-md-8 mb-5">
                    <h3>Herzlich willkommen in unserem WMK - Servicecenter</h3>
                    <hr>

                    <p>Ihre Zufriedenheit ist unsere höchste Priorität. Daher haben Sie hier die Möglichkeit, Ihr Anliegen ohne Wartezeit rund um die Uhr und in nur wenigen Schritten zu bearbeiten!</p>

                    <p>Ob ein Umtausch der Ware oder ein kompletten Rücktritt vom Kauf zur Erstattung Ihrer Zahlung – mit nur wenigen Klicks erhalten Sie spielend einfach unseren Retourenschein für eine bequeme Rücksendung.</p>

                    <p>Wünschen Sie anstelle einer Rücksendung lieber eine Nachsendung von Ersatzteilen oder einen Nachlass auf Ihren Kaufpreis? Gerne! In wenigen Minuten ist Ihr Anliegen bei uns.</p>

                    <p>Wir freuen uns, Ihren Kauf zu Ihrer Zufriedenheit bearbeiten zu dürfen! Ihr WMK Trading Team !</p>

                </div>
                <div class="col-md-4 mb-5">
                    <h3>Melden Sie sich an!</h3>
                    <hr>
                    <p class="small">
                        Bitte loggen Sie sich einfach mit Ihrer Rechnungs- oder Lieferschein-Nr. ein. Mit Eingabe Ihrer Postleitzahl werden die Daten Ihres Kaufs abgeglichen und Sie können direkt starten!
                    </p>

                    <login-form> </login-form>

                </div>


            </div>

            <div class="row">
                <div class="col-md-4 mb-5">
                    <div class="card h-100">
                        <img class="card-img-top" :src="require('../assets/service.png')" width="300" height="200" alt="">
                        <div class="card-body">
                            <h4 class="card-title">Gast oder Neukunde?</h4>
                            <p class="card-text">Sie sind noch kein Kunde bei uns oder haben als Gast bestellt?</p>
                          <button @click="withoutlogin" class="btn btn-info btn-block" type="button">Nachricht schreiben</button>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 mb-5">
                    <div class="card h-100">
                        <img class="card-img-top" :src="require('../assets/retoure.png')" width="300" height="200" alt="">
                        <div class="card-body">
                            <h4 class="card-title">Schnelle Abwicklung</h4>
                            <p class="card-text">Egal ob Rücksendung oder Ersatz - Durch unsere Versandpartner geht es für Sie immer ganz schnell!</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 mb-5">
                    <div class="card h-100">
                        <img class="card-img-top" :src="require('../assets/question.png')" width="300" height="200" alt="">
                        <div class="card-body">
                            <h4 class="card-title">Fragen? - Antworten!</h4>
                            <p class="card-text">Sie haben noch Fragen? Bei uns bekommen Sie immer die richtigen Antworten!</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>




    </div>

</template>

<script>

    import loading from '../components/loading'
    import LoginForm from '../components/LoginForm'
    import TopHeader from '../components/Header'

    export default {
        name: "login",

        components: {
            loading,
            LoginForm,
            TopHeader
        },

        methods: {
          withoutlogin () {
            this.$store.commit('setLoginStatus', 'withoutlogin')
          }
        }
    }
</script>

<style scoped>

    .login .row {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100vh;
    }

    .logo {
        font-size: 3.5em;
        color: #fff;
        background-color: #666;
        display: inline-block;
        width: 122px;
        border-radius: 108px;
        padding: 19px;
        margin-bottom: 25px;
    }

</style>

<style>
    .bg-danger {
        background-color: #e54949!important;
        color: #fff!important;
    }
</style>